import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import IMensagem from 'Models/chat/IMensagem'
import IUsuario from 'Models/docas/Usuario'
import ApiService from 'Services/ApiService'
import {
  ServiceCreateResponse,
  ServiceListResponse,
} from 'Types/ServiceResponse'

const mensagens = {
  getMensagemByHorario: async (cdHorario: number) => {
    const result: AxiosResponse<ServiceListResponse<IMensagem, IUsuario>> =
      await ApiService().get<ServiceListResponse<IMensagem, IUsuario>>(
        `${hosts.WS_CHAT}/mensagem_horario?cdHorario=${cdHorario}`,
      )

    return result
  },

  postMensagem: async (
    cdHorario: number,
    mensagem: string,
    placaVeiculo: string,
    transportadora: string,
    cdEntidade?: number,
    cdVeiculo?: number,
    cdDestinatario?: string[],
    cdAgendamentoDocasArmazem?: number,
    cdAgendamentoDocasArmazemConfig?: number,
    cdAgendamentoDocasDocas?: number,
  ) => {
    const destinatariosAux = cdDestinatario?.map((x) => parseInt(x))

    const result: AxiosResponse<ServiceCreateResponse> =
      await ApiService().post<ServiceCreateResponse>(
        `${hosts.WS_CHAT}/mensagem`,
        {
          cdHorario,
          cdDestinatarios: destinatariosAux,
          mensagem,
          placaVeiculo,
          transportadora,
          cdEntidade,
          cdVeiculo,
          cdAgendamentoDocasArmazem,
          cdAgendamentoDocasDocas,
          cdAgendamentoDocasArmazemConfig,
        },
      )

    return result
  },
}

export default mensagens
